import React from 'react';

export default class HeaderTemplate extends React.Component {
    render() {
        return (
            <div style={{margin:"auto", marginRight: "1cm",float:'left'}}>
                <img style={{width:"100%",display:"block",paddingTop:"5px",paddingBottom:"15px"}} src="/assets/app/media/img/logo2.jpg"/>
            </div>
        );
    }
}
